<template>
  <footer class="footer">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-half">
          <a href="https://bulma.io">
            <img
              src="https://bulma.io/images/made-with-bulma--white.png"
              alt="Made with Bulma"
              width="128"
              height="24"
            />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'CotizrFooter'
}
</script>

<style lang="scss">
</style>
